import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { IcUserIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { Avatar, AvatarTypes } from 'APP/components/Avatar/Avatar';
import { useUserProfile } from 'APP/main/hooks/userProfile/useUserProfile';

import styles from './styles.m.scss';

export const Contact = observer(({ message, className, avatarType = null }) => {
  const { user, name, phone, showStartChatButton, appContact } = message.payload;
  const { t } = useTranslation();
  const containerClass = classNames(styles.container, className);
  const userProfile = useUserProfile(user?.id, { groupId: message.groupId, messageId: message.id });

  return (
    <>
      <div className={containerClass}>
        {(!appContact || !user) && (
          <div className={styles.iconContainer}>
            <IcUserIcon className={styles.icon} />
          </div>
        )}
        {appContact && user && (
          <button onClick={userProfile.show}>
            <Avatar
              title={user.avatarTitle}
              url={user.avatarUrl}
              backgroundColorIndex={user.avatarColorIndex}
              type={avatarType || AvatarTypes.Round_10}
            />
          </button>
        )}
        <div className={styles.previewContent}>
          <div className={styles.name}>{name}</div>
          {!!phone && <div className={styles.phone}>{`+${phone}`}</div>}
        </div>
      </div>
      {showStartChatButton && user && (
        <Button
          className={styles.button}
          size="0"
          onClick={user.startChat}
          theme="outline-primary"
        >
          {t('shared_contact_start_chat')}
        </Button>
      )}
    </>
  );
});
